module.exports = __webpack_public_path__ + "img/tuin_mediterrane-hoek.1053be9c.png";